import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { RestorePasswordContext } from './RestorePasswordContext';
import MainPage from './MainPage';
import PhonePage from './PhonePage';
import EmailPage from './EmailPage';
import ContractPage from './ContractPage';
import OTPPage from './OTPPage';
import SetNewPage from './SetNewPage';

export default ({ match }) => {
  const [contextState, setContextState] = useState({
    code: '+380',
    phone: '',
    email: '',
    otp: '',
    isSeveralContracts: false,
  });

  return (
    <RestorePasswordContext.Provider value={{ contextState, setContextState }}>
      <Switch>
        <Route exact path={`${match.url}/`} component={MainPage} />
        <Route exact path={`${match.url}/phone`} component={PhonePage} />
        <Route exact path={`${match.url}/email`} component={EmailPage} />
        <Route exact path={`${match.url}/contract`} component={ContractPage} />
        <Route exact path={`${match.url}/otp`} component={OTPPage} />
        <Route exact path={[`${match.url}/set-new`, `${match.url}/repeat`]} component={SetNewPage} />
      </Switch>
    </RestorePasswordContext.Provider>
  );
};
